module.exports = __webpack_public_path__ + "img/mobile-clock-wallpaper.6b4d882b.jpg";